import { render, staticRenderFns } from "./CollectionFilterControlTypeDateDate.vue?vue&type=template&id=82e004a6"
import script from "./CollectionFilterControlTypeDateDate.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionFilterControlTypeDateDate.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports